import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                selectPayment: 'Select Payment Method',
                payViaBank: 'Pay via Bank',
                payViaCard: 'Pay via Card',
                smartChoice: 'Smart Choice',
                paySubjectOrder: 'Order {{label}}',
                paySubjectCompleted: 'Order {{label}}',
                paySubjectTip: 'Tip for order {{label}}',
                paySubjectPackage: 'Package {{label}}',
                payHostedTile: 'Continue to payment',
                payWalletHint: 'Pay with Apple Pay or Google Pay',
                payWalletNote: 'Opens the secure payment page where you can pick a wallet.',
                payMethodsUnavailable: 'Online payment is temporarily unavailable. Please try again in a minute.',
                payAmountChanged: 'The amount has changed. Please check the new amount and choose a payment method again.',
                refuseTitle: 'Payment not available',
                refuseNotFound: 'We could not find anything to pay for this link. Check the link or contact our support team.',
                refuseCancelled: 'This payment is no longer available.',
                refuseNothingToPay: 'Nothing left to pay.',
                refuseAlreadyPaid: 'Already paid. No further payment is needed.',
                refuseAlreadyTipped: 'This tip has already been paid.',
                refuseTipPendingInApp: 'This tip is waiting in the app. Please finish it there.',
                refuseNotAvailable: 'Online payment is temporarily unavailable. Please try again later or contact our support team.',
                refusePaymentInReview: "You already started a payment for this order. Please don't pay again. If it didn't go through, contact our support team.",
                processing: 'Processing…',
                ratingSaveError: 'Something went wrong while saving your rating. Please try again.',
                howWasYourCleaning: "How was your cleaning?",
                leaveYourFeedback: "Leave your feedback",
                addATip: "Add a tip?",
                done: "DONE",
                thankYouFeedback: "Thank you for your feedback, we have recorded it. Please check your email.",
                commReplySending: 'Sending your reply…',
                commReplyThankYou: "Thank you — we've let your cleaner know.",
                commReplyError: 'Something went wrong. Please try again.',
                contactDetailsTitle: 'Before payment',
                contactDetailsSubtitle: 'We need your name and email for the payment receipt.',
                fullNameLabel: 'Full name',
                fullNamePlaceholder: 'Jane Doe',
                emailLabel: 'Email',
                emailPlaceholder: 'you@example.com',
                nameTooShort: 'Please enter your full name',
                invalidEmail: 'Please enter a valid email',
                continueToPayment: 'Continue to payment',
                savingDetails: 'Saving…',
                saveFailed: 'Something went wrong. Please try again.',
                criticalErrorTitle: 'Something went wrong',
                criticalErrorBody: "We can't process this payment link. Please contact our support team and we'll help you right away.",
                contactSupport: 'Contact support',
                paymentPreparing: 'Preparing your payment…',

                buyPackageTitle: 'Buy Cleaning Package',
                addressLabel: 'Address:',
                flatLabel: 'Flat:',
                propertyTypeLabel: 'Property type:',
                loadingPackageDetails: 'Loading package details…',
                howItWorksButton: 'How It Works',
                howItWorksTitle: 'How Cleaning Packages Work',
                howItWorksFlexible: "Flexible Scheduling: Choose how often you'd like a cleaning — weekly, every 2 weeks, or every 3 weeks.",
                howItWorksCost: 'Cost Efficiency: Save more when you book a package upfront — the more cleanings, the bigger the discount.',
                howItWorksPriority: 'Priority Access: Package customers get priority booking and preferred time slots.',
                howItWorksPause: 'Pause Anytime: Need to skip a cleaning? Just let us know — your unused cleanings stay on your account.',
                howItWorksCustomizable: 'Customizable: Add extra services like fridge or oven cleaning before each cleaning, right in the app — no need to commit upfront.',
                closeButton: 'Close',
                chooseAddressLabel: 'Cleaning address',
                chooseAddressPlaceholder: 'Select an address',
                choosePackageLabel: 'Choose Your Package',
                choosePackagePlaceholder: 'Select a package',
                cleaningsSummary: '{{paid}} paid cleanings plus {{bonus}} free, {{total}} in total',
                firstDateLabel: 'First Cleaning Date',
                preferredTimeLabel: 'Choose Preferred Time',
                preferredTimePlaceholder: 'Select a time',
                frequencyLabel: 'Cleaning Frequency',
                frequencyPlaceholder: 'Select frequency',
                frequencyWeekly: 'Weekly',
                frequencyBiweekly: 'Every 2 weeks',
                frequencyTriweekly: 'Every 3 weeks',
                frequencyDiscount: '{{percent}}% off',
                freeServiceLabel: 'Include Free Additional Service',
                freeServicePlaceholder: 'Select a free service',
                additionalOptionsLabel: 'Additional Options',
                addonsPerCleaningNote: 'Extras are added to every cleaning in the package.',
                addonsUnavailable: 'Some extras are temporarily unavailable.',
                promoQuantityLabel: 'Quantity',
                promoVariantNone: 'No, thank you',
                promoLockedNote: 'Available with: {{packages}}',
                promoDecrease: 'Decrease',
                promoIncrease: 'Increase',
                commentsLabel: 'Comments',
                commentsPlaceholder: 'Any special instructions or requests?',
                priceBreakdownTitle: 'Your price',
                quoteLoading: 'Calculating your price…',
                quoteIncomplete: 'Pick an address, a package and a frequency to see your price.',
                quoteFailed: 'We could not calculate the price. Please check your selection.',
                quoteLineBase: 'Cleaning',
                quoteLineCadenceDiscount: 'Frequency discount',
                quoteLinePerCleaning: 'Per cleaning',
                quoteLineCleanings: 'Paid cleanings',
                quoteLineSuburban: 'Outside Tallinn',
                totalOnlyLabel: 'Total',
                perCleaningNote: '{{price}} per cleaning across {{count}} cleanings.',
                buyPackageButton: 'Buy Package',
                checkoutStarting: 'Opening secure payment…',
                checkoutFailed: 'We could not open the payment page. Please try again.',
                selectFirstDateError: 'Please fill in all required fields including the first cleaning date.',
                firstDateTooEarly: 'The first cleaning cannot be today. Please pick tomorrow or later.',
                selectGiftError: 'Please choose your free additional service.',
                loadFailedTitle: 'Something went wrong',
                loadFailedBody: "We couldn't load your package details. Please contact our support team.",
                invalidLinkBody: 'This link is missing required information. Please contact our support team.',
                noAddressTitle: 'No cleaning history yet',
                noAddressBody: 'Packages are priced from your previous cleaning and we could not find one on this account. Please contact our support team and we will set it up for you.',

                orderOptionsTitle: 'Enhance your cleaning',
                orderOptionsSummary: 'Cleaning on {{date}} at {{time}}',
                orderOptionsAddressLabel: 'Address:',
                orderOptionsPropertyLabel: 'Property type:',
                orderOptionsScheduleLabel: 'Schedule:',
                orderOptionsCurrentOptionsLabel: 'Current options:',
                orderOptionsCurrentWindowsLabel: 'Window cleaning:',
                orderOptionsPriceLabel: 'Current price: €{{price}}',
                orderOptionsLoadingDetails: 'Loading order details…',
                orderOptionsAddOptionsLabel: 'Add more options',
                orderOptionsSubmitButton: 'Enhance Your Cleaning',
                orderOptionsPayOutstanding: 'Or pay outstanding',
                orderOptionsValidationError: 'Please select at least one option to add.',
                orderOptionsConfirm: 'Are you sure you want to add the selected options to your order?',

                successPaymentChecking: 'Verifying your payment…',
                successPaymentSuccessTitle: 'Payment received',
                successPaymentSuccessBody: 'Thank you! Your receipt is on its way to your inbox. Returning to the homepage in a moment.',
                successPaymentSuccessReceipt: 'Thank you! Your receipt is on its way to your inbox.',
                successPaymentPendingTitle: 'Payment is being processed',
                successPaymentPendingBody: 'This usually takes up to a minute. Refresh this page in a minute or check your email.',
                successPaymentFailedTitle: "Payment didn't go through",
                successPaymentFailedBody: 'Please try the payment again. If the issue persists, contact our support.',
                successPaymentInvalidLink: 'This link is missing the payment reference. Please use the return link from your bank or contact our support.',
                successPaymentTipBody: 'Thank you for the tip. It goes straight to your cleaner.',
                successPaymentCompletedBody: 'Thank you. The balance for this order is settled.',
                successPaymentPackageLinkBody: 'Thank you. Your cleaning package is paid and we will confirm the details by email.',
                successCheckingTitle: 'Payment is being checked',
                successCheckingBody: 'We received your payment and are checking it. Support will contact you.',
                successPaymentGoHome: 'Go to homepage',
                successPaymentTryAgain: 'Try payment again',
                successPaymentPackageTitle: 'Package confirmed',
                successPaymentPackageBody: 'Your cleaning package is paid. We will be in touch to confirm your first cleaning.',
                successPaymentPackageNumber: 'Package number',
                successPaymentPackageType: 'Package',
                successPaymentPackageFirstCleaning: 'First cleaning',
                successPaymentPackageCleanings: 'Cleanings included',
                successPaymentPackagePaid: 'Amount paid',
                successPaymentPackageDateTime: '{{date}} at {{time}}',
                successPaymentPackagePendingBody: 'We have not received the confirmation for this package yet. This usually takes up to a minute. Refresh this page shortly or check your email.',
                successPaymentPackageErrorBody: 'We could not load the details for package #{{nr}}. If your payment went through, the confirmation is on its way to your inbox. Contact our support if you need help.',

                bliqConsentLoading: 'Loading…',
                bliqConsentTitle: 'Your cleaner arrives in a driverless car from Bliq',
                bliqConsentWhen: 'Your cleaning: {{date}} at {{time}}',
                bliqConsentWhenNoTime: 'Your cleaning: {{date}}',
                bliqConsentBody: 'Your cleaner arrives in a driverless car from our partner Bliq, and you are invited to experience it yourself, straight from your doorstep.\n\nAfter the cleaner arrives, you can take a 10-15 minute demo ride and see how everyday travel could feel when the car becomes your own chauffeur, handling the drive while you sit back and focus on what matters to you. The ride costs nothing, and a trained safety driver is at the wheel the whole time.\n\nIf you would rather go somewhere, the car can drop you nearby or take you there and back. You settle a short route with the safety driver on the spot.',
                bliqConsentShareNote: 'If you say yes, we share your name and email with Bliq so they can arrange the ride. Nothing else changes.',
                bliqConsentPrivacy: 'Bliq privacy policy',
                bliqConsentMore: 'More about Bliq',
                bliqConsentAgreeDemo: 'Yes, a demo ride',
                bliqConsentAgreeDropoff: 'Yes, drop me nearby',
                bliqConsentAgreeReturn: 'Yes, there and back',
                bliqConsentDecline: 'No thanks',
                bliqConsentThanksTitle: 'Thank you!',
                bliqConsentThanksBody: 'We have let Bliq know. They will arrange your ride.',
                bliqConsentDeclinedTitle: 'No problem',
                bliqConsentDeclinedBody: 'Your cleaner will still arrive as usual.',
                bliqConsentResolvedTitle: 'Already answered',
                bliqConsentResolvedBody: 'You have already responded to this invitation.',
                bliqConsentExpiredTitle: 'Link expired',
                bliqConsentExpired: 'This invitation link has expired.',
                bliqConsentErrorTitle: 'Something went wrong',
                bliqConsentError: 'Something went wrong. Please try again.',

                bliqConfirmLoading: 'Loading…',
                bliqConfirmTitle: 'Confirm transport',
                bliqConfirmIntro: 'Please review each route, enter the vehicle registration number and confirm or decline it.',
                bliqConfirmDate: 'Date',
                bliqConfirmRoute: 'Route',
                bliqConfirmToClient: 'Client rides',
                bliqConfirmRegLabel: 'Vehicle registration number',
                bliqConfirmRegRequired: 'Please enter the vehicle registration number.',
                bliqConfirmConfirm: 'Confirm',
                bliqConfirmConfirming: 'Confirming…',
                bliqConfirmDecline: 'Decline',
                bliqConfirmStatusPending: 'Pending',
                bliqConfirmStatusConfirmed: 'Confirmed',
                bliqConfirmStatusDeclined: 'Declined',
                bliqConfirmAllSet: 'All routes are set. Thank you!',
                bliqConfirmNoRoutes: 'No routes to confirm.',
                bliqConfirmFailed: 'Confirmation failed. Please try again.',
                bliqConfirmErrorTitle: 'Link not valid',
                bliqConfirmErrorBody: 'This confirmation link could not be opened. Please contact WiseClean.',
                bliqConfirmExpiredTitle: 'Link expired',
                bliqConfirmExpiredBody: 'This confirmation link has expired. Please ask WiseClean to resend it.',

                dataConsentTitle: 'Help teach robots to clean',
                dataConsentBody: 'WiseClean and Aule Labs Incorporated (USA) would like to record some of your cleaning visits with your cleaner\'s wearable camera. The recordings help teach robots household skills, help us improve our service quality, and protect you: there is always a trusted record of what happened during the visit.\n\nChildren are never recorded. Everyone in the footage except the cleaner is removed or masked before any use. You can tell the cleaner to pause or stop at any moment, and you can withdraw your consent at any time. This never affects your cleaning.',
                dataConsentVideo: 'I agree to video recording',
                dataConsentAudio: 'I agree to audio recording (voices will be audible)',
                dataConsentNoVideoHint: 'With video switched off, nothing is recorded.',
                dataConsentTerms: 'Read the full terms',
                dataConsentAgree: 'Agree and join',
                dataConsentDecline: 'Not now',
                dataConsentThanksTitle: 'Thank you!',
                dataConsentThanksBody: 'Your consent is recorded. You can change your mind at any time, just message us.',
                dataConsentDeclinedTitle: 'All right',
                dataConsentDeclinedBody: 'We will not record your visits. You can join any time later.',
                dataConsentError: 'Something went wrong. Please try again.',

                // Beta feedback form (/external/beta-feedback/:lang/:userId).
                // Question keys are betaFeedbackQ_<id>, help is betaFeedbackQ_<id>_help.
                // Ids live in src/pages/BetaFeedback/questions.js and double as
                // payload keys.
                betaFeedbackTitle: 'A minute about the new app',
                betaFeedbackIntro: 'You are one of the first people we invited to the new WiseClean app. Three questions, about a minute. Answer them and we will send you a €5 code for your next cleaning.',
                betaFeedbackSubmit: 'Send My Answers',
                betaFeedbackSubmitting: 'Sending',
                betaFeedbackThanksTitle: 'Thank you',
                betaFeedbackThanksBody: 'We read every answer. Your €5 code comes by email within a few days, to the address this form came to. It works on one cleaning.',
                betaFeedbackErrorBody: 'Something went wrong and your answers did not reach us. Try again in a moment. If it keeps failing, write to info@wiseclean.eu and we will sort it out.',
                betaFeedbackAlreadyBody: 'You have already filled in this form. Your €5 code is on its way by email. One code per person.',
                betaFeedbackTryAgain: 'Try Again',
                betaFeedbackRequiredText: 'Please write a sentence here.',

                betaFeedbackQ_liked_most: 'What did you like most?',
                betaFeedbackQ_liked_most_help: 'One sentence is enough.',

                betaFeedbackQ_liked_least: 'What did you like least?',
                betaFeedbackQ_liked_least_help: 'Be blunt. This is the part we read first.',

                betaFeedbackQ_one_feature: 'If you could add exactly one feature to WiseClean, what would it be?',
                betaFeedbackQ_one_feature_help: 'Only one, even if it sounds unrealistic.',
            },
        },
        et: {
            translation: {
                selectPayment: 'Valige maksemeetod',
                payViaBank: 'Maksa pangaga',
                payViaCard: 'Maksa kaardiga',
                smartChoice: 'Tark valik',
                paySubjectOrder: 'Tellimus {{label}}',
                paySubjectCompleted: 'Tellimus {{label}}',
                paySubjectTip: 'Jootraha tellimusele {{label}}',
                paySubjectPackage: 'Pakett {{label}}',
                payHostedTile: 'Jätka maksmisega',
                payWalletHint: "Maksa Apple Pay või Google Pay'ga",
                payWalletNote: 'Avab turvalise makselehe, kus saate valida rahakoti.',
                payMethodsUnavailable: 'Veebis maksmine ei ole ajutiselt saadaval. Palun proovige minuti pärast uuesti.',
                payAmountChanged: 'Summa on muutunud. Palun kontrollige uut summat ja valige makseviis uuesti.',
                refuseTitle: 'Makse pole saadaval',
                refuseNotFound: 'Me ei leidnud selle lingiga seotud makset. Kontrollige linki või võtke ühendust klienditoega.',
                refuseCancelled: 'See makse ei ole enam saadaval.',
                refuseNothingToPay: 'Tasuda pole midagi.',
                refuseAlreadyPaid: 'Juba tasutud. Uut makset pole vaja.',
                refuseAlreadyTipped: 'See jootraha on juba makstud.',
                refuseTipPendingInApp: 'See jootraha ootab rakenduses. Palun lõpetage makse seal.',
                refuseNotAvailable: 'Veebis maksmine ei ole ajutiselt saadaval. Palun proovige hiljem uuesti või võtke ühendust klienditoega.',
                refusePaymentInReview: 'Te olete selle tellimuse makset juba alustanud. Palun ärge makske uuesti. Kui makse ei õnnestunud, võtke ühendust klienditoega.',
                processing: 'Töötlemine…',
                ratingSaveError: 'Hinnangu salvestamisel läks midagi valesti. Palun proovige uuesti.',
                howWasYourCleaning: "Kuidas oli teie koristamine?",
                leaveYourFeedback: "Jäta oma tagasiside",
                addATip: "Lisa jootraha?",
                done: "VALMIS",
                thankYouFeedback: "Aitäh tagasiside eest, oleme selle salvestanud. Palun kontrollige oma e-posti.",
                commReplySending: 'Saadame teie vastust…',
                commReplyThankYou: 'Aitäh — andsime teie koristajale teada.',
                commReplyError: 'Midagi läks valesti. Palun proovige uuesti.',
                contactDetailsTitle: 'Enne maksmist',
                contactDetailsSubtitle: 'Vajame teie nime ja e-posti maksekviitungi jaoks.',
                fullNameLabel: 'Täisnimi',
                fullNamePlaceholder: 'Jaan Tamm',
                emailLabel: 'E-post',
                emailPlaceholder: 'teie@naide.ee',
                nameTooShort: 'Palun sisestage oma täisnimi',
                invalidEmail: 'Palun sisestage kehtiv e-posti aadress',
                continueToPayment: 'Jätka maksmisega',
                savingDetails: 'Salvestan…',
                saveFailed: 'Midagi läks valesti. Palun proovige uuesti.',
                criticalErrorTitle: 'Midagi läks valesti',
                criticalErrorBody: 'Me ei saa seda makselinki töödelda. Võtke palun ühendust meie klienditoega ja aitame teid kohe.',
                contactSupport: 'Võtke ühendust',
                paymentPreparing: 'Valmistame teie makset ette…',

                buyPackageTitle: 'Osta koristuspakett',
                addressLabel: 'Aadress:',
                flatLabel: 'Korter:',
                propertyTypeLabel: 'Kinnisvara tüüp:',
                loadingPackageDetails: 'Pakettide andmete laadimine…',
                howItWorksButton: 'Kuidas see töötab',
                howItWorksTitle: 'Kuidas koristuspaketid töötavad',
                howItWorksFlexible: 'Paindlik ajakava: vali endale sobiv sagedus — iga nädal, iga 2 nädala või iga 3 nädala tagant.',
                howItWorksCost: 'Kulutõhusus: säästa rohkem, kui broneerid paketi ette — mida rohkem koristusi, seda suurem allahindlus.',
                howItWorksPriority: 'Eelistatud juurdepääs: paketiklientidel on broneerimisel eelis ja paremad ajavalikud.',
                howItWorksPause: 'Peata igal ajal: pead koristuse vahele jätma? Anna meile teada — kasutamata koristused jäävad sinu kontole.',
                howItWorksCustomizable: 'Kohandatav: lisa lisateenuseid (nt külmiku või ahju puhastus) enne iga koristust otse rakenduses — ei pea kõike paketti ette panema.',
                closeButton: 'Sulge',
                chooseAddressLabel: 'Koristuse aadress',
                chooseAddressPlaceholder: 'Vali aadress',
                choosePackageLabel: 'Vali oma pakett',
                choosePackagePlaceholder: 'Vali pakett',
                cleaningsSummary: '{{paid}} tasulist koristust ja {{bonus}} tasuta, kokku {{total}}',
                firstDateLabel: 'Esimese koristuse kuupäev',
                preferredTimeLabel: 'Vali sobiv kellaaeg',
                preferredTimePlaceholder: 'Vali kellaaeg',
                frequencyLabel: 'Koristuse sagedus',
                frequencyPlaceholder: 'Vali sagedus',
                frequencyWeekly: 'Iga nädal',
                frequencyBiweekly: 'Iga 2 nädala tagant',
                frequencyTriweekly: 'Iga 3 nädala tagant',
                frequencyDiscount: '{{percent}}% soodsam',
                freeServiceLabel: 'Lisa tasuta lisateenus',
                freeServicePlaceholder: 'Vali tasuta teenus',
                additionalOptionsLabel: 'Lisavalikud',
                addonsPerCleaningNote: 'Lisavalikud lisatakse paketi igale koristusele.',
                addonsUnavailable: 'Osa lisavalikuid ei ole hetkel saadaval.',
                promoQuantityLabel: 'Kogus',
                promoVariantNone: 'Ei, aitäh',
                promoLockedNote: 'Saadaval pakettidega: {{packages}}',
                promoDecrease: 'Vähenda',
                promoIncrease: 'Suurenda',
                commentsLabel: 'Kommentaarid',
                commentsPlaceholder: 'Kas on erisoove või juhiseid?',
                priceBreakdownTitle: 'Sinu hind',
                quoteLoading: 'Arvutame hinda…',
                quoteIncomplete: 'Hinna nägemiseks vali aadress, pakett ja sagedus.',
                quoteFailed: 'Me ei saanud hinda arvutada. Palun kontrolli oma valikuid.',
                quoteLineBase: 'Koristus',
                quoteLineCadenceDiscount: 'Sagedusallahindlus',
                quoteLinePerCleaning: 'Ühe koristuse hind',
                quoteLineCleanings: 'Tasulisi koristusi',
                quoteLineSuburban: 'Väljaspool Tallinna',
                totalOnlyLabel: 'Kokku',
                perCleaningNote: '{{price}} koristuse kohta, kokku {{count}} koristust.',
                buyPackageButton: 'Osta pakett',
                checkoutStarting: 'Avame turvalise makse…',
                checkoutFailed: 'Me ei saanud makselehte avada. Palun proovi uuesti.',
                selectFirstDateError: 'Palun täida kõik kohustuslikud väljad, sealhulgas esimese koristuse kuupäev.',
                firstDateTooEarly: 'Esimene koristus ei saa olla täna. Palun vali homme või hiljem.',
                selectGiftError: 'Palun vali oma tasuta lisateenus.',
                loadFailedTitle: 'Midagi läks valesti',
                loadFailedBody: 'Me ei saanud pakettide andmeid laadida. Võtke palun ühendust klienditoega.',
                invalidLinkBody: 'Sellelt lingilt puudub vajalik teave. Võtke palun ühendust klienditoega.',
                noAddressTitle: 'Varasemat koristust ei leidnud',
                noAddressBody: 'Paketi hind arvutatakse sinu eelmise koristuse põhjal ja me ei leidnud seda kontolt. Võtke palun ühendust klienditoega ja me seadistame selle teie eest.',

                orderOptionsTitle: 'Täienda oma koristust',
                orderOptionsSummary: 'Koristus {{date}} kell {{time}}',
                orderOptionsAddressLabel: 'Aadress:',
                orderOptionsPropertyLabel: 'Kinnisvara tüüp:',
                orderOptionsScheduleLabel: 'Sagedus:',
                orderOptionsCurrentOptionsLabel: 'Praegused valikud:',
                orderOptionsCurrentWindowsLabel: 'Aknapesu:',
                orderOptionsPriceLabel: 'Praegune hind: €{{price}}',
                orderOptionsLoadingDetails: 'Tellimuse andmete laadimine…',
                orderOptionsAddOptionsLabel: 'Lisa rohkem valikuid',
                orderOptionsSubmitButton: 'Täienda koristust',
                orderOptionsPayOutstanding: 'Või tasu võlgnevus',
                orderOptionsValidationError: 'Palun vali vähemalt üks valik, mida lisada.',
                orderOptionsConfirm: 'Kas oled kindel, et soovid lisada valitud valikud oma tellimusele?',

                successPaymentChecking: 'Kontrollime makset…',
                successPaymentSuccessTitle: 'Makse vastu võetud',
                successPaymentSuccessBody: 'Aitäh! Kviitung saabub teie e-postile. Suuname avalehele paari sekundi pärast.',
                successPaymentSuccessReceipt: 'Aitäh! Kviitung saabub teie e-postile.',
                successPaymentPendingTitle: 'Makse on töötlemisel',
                successPaymentPendingBody: 'See võtab kuni minuti. Värskendage lehte minuti pärast või kontrollige e-posti.',
                successPaymentFailedTitle: 'Makse ei õnnestunud',
                successPaymentFailedBody: 'Proovige makset uuesti. Kui probleem püsib, võtke meiega ühendust.',
                successPaymentInvalidLink: 'Sellelt lingilt puudub makseviide. Palun kasutage panga tagasipöördumislinki või võtke ühendust klienditoega.',
                successPaymentTipBody: 'Täname jootraha eest. See jõuab otse teie koristajani.',
                successPaymentCompletedBody: 'Täname. Selle tellimuse saldo on tasutud.',
                successPaymentPackageLinkBody: 'Täname. Teie koristuspakett on tasutud ja kinnitame üksikasjad e-posti teel.',
                successCheckingTitle: 'Makset kontrollitakse',
                successCheckingBody: 'Saime teie makse kätte ja kontrollime seda. Klienditugi võtab teiega ühendust.',
                successPaymentGoHome: 'Avalehele',
                successPaymentTryAgain: 'Proovige makset uuesti',
                successPaymentPackageTitle: 'Pakett on kinnitatud',
                successPaymentPackageBody: 'Teie koristuspakett on tasutud. Võtame ühendust, et esimene koristus kinnitada.',
                successPaymentPackageNumber: 'Paketi number',
                successPaymentPackageType: 'Pakett',
                successPaymentPackageFirstCleaning: 'Esimene koristus',
                successPaymentPackageCleanings: 'Koristusi paketis',
                successPaymentPackagePaid: 'Makstud summa',
                successPaymentPackageDateTime: '{{date}} kell {{time}}',
                successPaymentPackagePendingBody: 'Me ei ole selle paketi kinnitust veel saanud. See võtab tavaliselt kuni minuti. Värskendage lehte veidi aja pärast või kontrollige oma e-posti.',
                successPaymentPackageErrorBody: 'Me ei saanud paketi #{{nr}} andmeid laadida. Kui makse õnnestus, saabub kinnitus teie e-postile. Vajadusel võtke ühendust klienditoega.',

                bliqConsentLoading: 'Laadimine…',
                bliqConsentTitle: 'Sinu koristaja saabub Bliqi juhita autoga',
                bliqConsentWhen: 'Sinu koristus: {{date}} kell {{time}}',
                bliqConsentWhenNoTime: 'Sinu koristus: {{date}}',
                bliqConsentBody: 'Sinu koristaja saabub meie partneri Bliqi juhita autoga ja sul on võimalus seda ise proovida, otse oma koduukselt.\n\nPärast koristaja saabumist saad teha 10-15-minutilise demosõidu ja kogeda, milline võiks välja näha igapäevane liikumine tulevikus: auto sõidab sinu eest ning sina saad samal ajal rahulikult istuda, ringi vaadata ja keskenduda sellele, mis on sulle oluline. Sõit ei maksa midagi ja roolis on kogu aeg väljaõppinud turvajuht.\n\nKui soovid hoopis kuhugi minna, saab auto viia su lähedale või viia sinna ja tuua tagasi. Lühikese marsruudi lepid turvajuhiga kohapeal kokku.',
                bliqConsentShareNote: 'Kui nõustud, jagame sinu nime ja e-posti Bliqiga, et nad saaksid sõidu korraldada. Muu ei muutu.',
                bliqConsentPrivacy: 'Bliqi privaatsuspoliitika',
                bliqConsentMore: 'Lisainfo Bliqi kohta',
                bliqConsentAgreeDemo: 'Jah, demosõit',
                bliqConsentAgreeDropoff: 'Jah, vii mind lähedale',
                bliqConsentAgreeReturn: 'Jah, sinna ja tagasi',
                bliqConsentDecline: 'Ei, aitäh',
                bliqConsentThanksTitle: 'Aitäh!',
                bliqConsentThanksBody: 'Andsime Bliqile teada. Nad korraldavad sinu sõidu.',
                bliqConsentDeclinedTitle: 'Pole probleemi',
                bliqConsentDeclinedBody: 'Sinu koristaja saabub ikka tavapäraselt.',
                bliqConsentResolvedTitle: 'Juba vastatud',
                bliqConsentResolvedBody: 'Oled sellele kutsele juba vastanud.',
                bliqConsentExpiredTitle: 'Link on aegunud',
                bliqConsentExpired: 'See kutselink on aegunud.',
                bliqConsentErrorTitle: 'Midagi läks valesti',
                bliqConsentError: 'Midagi läks valesti. Palun proovi uuesti.',

                bliqConfirmLoading: 'Laadimine…',
                bliqConfirmTitle: 'Kinnita transport',
                bliqConfirmIntro: 'Palun vaadake iga marsruut üle, sisestage sõiduki registreerimisnumber ning kinnitage või lükake see tagasi.',
                bliqConfirmDate: 'Kuupäev',
                bliqConfirmRoute: 'Marsruut',
                bliqConfirmToClient: 'Klient sõidab kaasa',
                bliqConfirmRegLabel: 'Sõiduki registreerimisnumber',
                bliqConfirmRegRequired: 'Palun sisestage sõiduki registreerimisnumber.',
                bliqConfirmConfirm: 'Kinnita',
                bliqConfirmConfirming: 'Kinnitan…',
                bliqConfirmDecline: 'Lükka tagasi',
                bliqConfirmStatusPending: 'Ootel',
                bliqConfirmStatusConfirmed: 'Kinnitatud',
                bliqConfirmStatusDeclined: 'Tagasi lükatud',
                bliqConfirmAllSet: 'Kõik marsruudid on määratud. Aitäh!',
                bliqConfirmNoRoutes: 'Pole marsruute, mida kinnitada.',
                bliqConfirmFailed: 'Kinnitamine ebaõnnestus. Palun proovige uuesti.',
                bliqConfirmErrorTitle: 'Link ei kehti',
                bliqConfirmErrorBody: 'Seda kinnituslinki ei õnnestunud avada. Palun võtke ühendust WiseCleaniga.',
                bliqConfirmExpiredTitle: 'Link on aegunud',
                bliqConfirmExpiredBody: 'See kinnituslink on aegunud. Palun paluge WiseCleanil see uuesti saata.',

                dataConsentTitle: 'Aidake õpetada roboteid koristama',
                dataConsentBody: 'WiseClean ja Aule Labs Incorporated (USA) soovivad salvestada osa teie koristuskülastustest koristaja kantava kaameraga. Salvestised aitavad õpetada robotitele majapidamistöid, aitavad meil teenuse kvaliteeti parandada ja kaitsevad teid: külastuse kohta on alati olemas usaldusväärne salvestis.\n\nLapsi ei salvestata kunagi. Kõik kaadrisse jäävad inimesed peale koristaja eemaldatakse või maskitakse enne igasugust kasutamist. Võite igal hetkel paluda koristajal salvestamine peatada ning võite nõusoleku igal ajal tagasi võtta. See ei mõjuta kunagi teie koristust.',
                dataConsentVideo: 'Nõustun videosalvestusega',
                dataConsentAudio: 'Nõustun helisalvestusega (hääled jäävad kuuldavaks)',
                dataConsentNoVideoHint: 'Kui video on välja lülitatud, ei salvestata midagi.',
                dataConsentTerms: 'Lugege täistingimusi',
                dataConsentAgree: 'Nõustun ja liitun',
                dataConsentDecline: 'Mitte praegu',
                dataConsentThanksTitle: 'Aitäh!',
                dataConsentThanksBody: 'Teie nõusolek on salvestatud. Meelt võite muuta igal ajal, lihtsalt kirjutage meile.',
                dataConsentDeclinedTitle: 'Selge',
                dataConsentDeclinedBody: 'Teie külastusi ei salvestata. Liituda saate igal ajal hiljem.',
                dataConsentError: 'Midagi läks valesti. Palun proovige uuesti.',

                // Beeta tagasiside vorm (/external/beta-feedback/:lang/:userId).
                // Vt EN-plokki võtmete skeemi kohta. "Sina" vorm, nagu mujal klientidega.
                betaFeedbackTitle: 'Üks minut uue äpi kohta',
                betaFeedbackIntro: 'Sa oled üks esimestest, keda me uut WiseCleani äppi proovima kutsusime. Kolm küsimust, umbes minut aega. Vasta ja saadame sulle €5 koodi järgmise koristuse jaoks.',
                betaFeedbackSubmit: 'Saada vastused',
                betaFeedbackSubmitting: 'Saadan',
                betaFeedbackThanksTitle: 'Aitäh',
                betaFeedbackThanksBody: 'Loeme iga vastuse läbi. €5 kood tuleb sulle e-postiga paari päeva jooksul, samale aadressile, kuhu see vorm tuli. Kood kehtib ühele koristusele.',
                betaFeedbackErrorBody: 'Midagi läks valesti ja vastused ei jõudnud meieni. Proovi hetke pärast uuesti. Kui see ikka ei õnnestu, kirjuta info@wiseclean.eu ja me lahendame selle ära.',
                betaFeedbackAlreadyBody: 'Sa oled selle vormi juba täitnud. Sinu €5 kood on e-postiga teel. Üks kood inimese kohta.',
                betaFeedbackTryAgain: 'Proovi uuesti',
                betaFeedbackRequiredText: 'Palun kirjuta siia üks lause.',

                betaFeedbackQ_liked_most: 'Mis sulle kõige rohkem meeldis?',
                betaFeedbackQ_liked_most_help: 'Ühest lausest piisab.',

                betaFeedbackQ_liked_least: 'Mis sulle kõige vähem meeldis?',
                betaFeedbackQ_liked_least_help: 'Ütle otse. Just seda me loeme esimesena.',

                betaFeedbackQ_one_feature: 'Kui saaksid WiseCleanile lisada täpselt ühe funktsiooni, mis see oleks?',
                betaFeedbackQ_one_feature_help: 'Ainult üks, ka siis, kui see kõlab ebareaalselt.',
            },
        },
    },
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
